import { useMemo } from 'react';
import { assertNever } from '../../utils/assert-never';
import { isButtonGroup, isCollapsibleGroup, isRuleGroup, isRuleGroupSectionDivider } from '../../utils/rule-groups-type-guard';
import { useAutoScrolling } from '../../utils/use-auto-scrolling';
import { useOnToggleFunctions } from '../../utils/use-on-toggle-functions';
import { getSectionDividerItem } from './get-section-divider-item';
import { useButtonGroup } from './use-get-button-group';
import { useCollapsibleGroup } from './use-get-collapsible-group';
export const useRuleGroupList = _ref => {
  let {
    ruleGroups,
    parentNodeRef
  } = _ref;
  const {
    selectedGroup
  } = useOnToggleFunctions();
  const {
    selectedItemHeaderRef,
    selectedItemContentRef
  } = useAutoScrolling((selectedGroup == null ? void 0 : selectedGroup.groupId) ?? null, parentNodeRef);
  const filteredRuleGroups = useMemo(() => {
    return ruleGroups.filter(isRuleGroup);
  }, [ruleGroups]);
  const getCollapsibleGroupItem = useCollapsibleGroup({
    parentNodeRef,
    ruleGroups: filteredRuleGroups,
    selectedItemContentRef,
    selectedItemHeaderRef
  });
  const getButtonGroupItem = useButtonGroup({
    ruleGroups: filteredRuleGroups,
    selectedItemHeaderRef
  });
  const ruleGroupItems = useMemo(() => (ruleGroups == null ? void 0 : ruleGroups.map(group => {
    if (isRuleGroup(group)) {
      if (isCollapsibleGroup(group)) {
        return getCollapsibleGroupItem(group);
      } else if (isButtonGroup(group)) {
        return getButtonGroupItem(group);
      }
    } else if (isRuleGroupSectionDivider(group)) {
      return getSectionDividerItem(group);
    }
    assertNever(group);
    return undefined;
  }).filter(group => group !== undefined)) || [], [getButtonGroupItem, getCollapsibleGroupItem, ruleGroups]);
  return {
    ruleGroupItems
  };
};
//# sourceMappingURL=use-rule-group-list.js.map